"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueTypeEnum = void 0;
var ValueTypeEnum;
(function (ValueTypeEnum) {
    /** 整数，后端统一使用64位无符号整数 */
    ValueTypeEnum["Int"] = "Int64";
    /** 浮点数 */
    ValueTypeEnum["Decimal"] = "Decimal";
    /** 字符串 */
    ValueTypeEnum["String"] = "String";
    /** SPU 引用 */
    ValueTypeEnum["Ref"] = "Ref";
    /** 整数数组 */
    ValueTypeEnum["IntArray"] = "Int64Array";
    /** 浮点数数组 */
    ValueTypeEnum["DecimalArray"] = "DecimalArray";
    /** 字符串数组 */
    ValueTypeEnum["StringArray"] = "StringArray";
    /** SPU 引用集合 */
    ValueTypeEnum["RefArray"] = "RefArray";
})(ValueTypeEnum || (exports.ValueTypeEnum = ValueTypeEnum = {}));
